import axiosBase from 'axios'
import { HOST_API_KEY } from '../config-global'

const axios = axiosBase.create({
  baseURL: HOST_API_KEY,
  headers: { 'X-Tenant': process.env.REACT_APP_TENANT_ID },
})

axios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
)

axiosBase
  .get('https://api.ipify.org?format=json', { withCredentials: false })
  .then(({ data }) => {
    axios.defaults.headers.common['X-Device-Ip'] = data.ip
  })
  .catch((error) => {
    console.error(error)
  })

export default axios
